import React from 'react';
import Button from './Button';
import '../strengthAnalysis/nav.css';
import Nav from '../Nav';
import { useLocation } from 'react-router-dom';

const Header = ({ title, save, refresh, del }) => {
  const location = useLocation();
  return (
    <div className='select-none	bg-blue-900 px-3 py-2 flex justify-between'>
      {/* <Nav className='fill-white' /> */}
      <div className='text-white font-medium text-2xl'>{title}</div>
      <div className='flex items-center'>
        <Button buttonAction={refresh} buttonText={'초기화(F11)'} />
        {
          location.pathname === "/" &&
          <>
            <Button buttonAction={save} buttonText={'저장(F9)'} />
            <Button buttonAction={del} buttonText={'삭제(F8)'} />
          </>
        }
      </div>
    </div>
  );
};

export default Header;
